import { useRoutes } from "react-router-dom";
import { routeConfig } from "../routes/routeConfig";

function AppRouter() {
  return useRoutes(routeConfig);
}

export default AppRouter;
